import type { RecordStatus } from '@sign/shared';

interface StatusBadgeProps {
  status: RecordStatus;
}

const LABELS: Record<RecordStatus, string> = {
  pending: '未确认',
  partial: '部分确认',
  done: '已确认',
  expired: '已过期',
  revoked: '已撤销',
};

/** Maps a record status to a badge color modifier. */
function variant(status: RecordStatus): 'gray' | 'green' | 'muted' {
  if (status === 'done') return 'green';
  if (status === 'expired' || status === 'revoked') return 'muted';
  return 'gray';
}

export default function StatusBadge({ status }: StatusBadgeProps) {
  return <span className={`badge badge--${variant(status)}`}>{LABELS[status]}</span>;
}
